<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful title="Delete Subcontractor :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors`">
                            <i class="fa fa-id-badge"></i> Subcontractors
                        </router-link>
                </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/subcontractors/view/${subcontractor_id}`">
                            {{ subcontractor.subcontractor_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">Delete</li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-6 col-lg-8 col-md-7">
                    <div class="card mb-3">
                        <div class="card-body">
                            <p>
                                You are about to delete a subcontractor along with all of their data, including any comments and uploaded files. This action is destructive and <strong>cannot be undone</strong>. Are you sure you want to delete the subcontractor {{ subcontractor.subcontractor_name }}?
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-danger" v-on:click="deleteSubcontractor(this)" :disabled="saving">
                <template v-if="saving"><i class="fa fa-spin fa-spinner"></i> Deleting</template>
                <template v-else>Delete</template>
                Subcontractor
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                subcontractor_id: this.$route.params.id,
                subcontractor: {},
            }
        },

        methods: {
            getSubcontractor: function() {
                //Get the data
                this.$http
                    .get(`subcontractors/edit/${this.subcontractor_id}`)
                    .then(response => {
                        //Set all the data
                        this.subcontractor = response.data.subcontractor;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            deleteSubcontractor: function() {
                //SHow loading
                this.saving = true;

                //Send it
                this.$http
                .post(`subcontractors/delete/${this.subcontractor_id}`, {})
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Subcontractor Deleted');

                    this.$router.push('/subcontractors');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the subcontractors
            this.getSubcontractor();
        }
    }
</script>
